import { buildDemoOrder } from 'customer-flows/demo/order'
import { DEMO_PAYMENT_METHOD } from 'customer-flows/demo/payment-method'

export default function demoPayment({ dispatch, stores }: CommandArgs) {
  const paymentStore = stores['payment']

  async function createOrdersFromQuotes(): Promise<void> {
    const quoteStore = stores['quote']
    const activityStore = stores['activity']
    const programStore = stores['program']
    const customerStore = stores['customer']

    paymentStore.paymentErrorCode = null

    const order = buildDemoOrder({ quoteStore, activityStore, programStore, customerStore })

    dispatch('order:setOrder', order)
    paymentStore.hasSuccessfulPayment = true
  }

  function initPaymentForm(): void {
    paymentStore.stripeFormReady = true
    paymentStore.paymentFormIsValid = true
    paymentStore.paymentMethod = DEMO_PAYMENT_METHOD
  }

  function updatePaymentFormState(): void {}
  function setPaymentMethod(): void {}

  return { createOrdersFromQuotes, initPaymentForm, updatePaymentFormState, setPaymentMethod }
}
